const $ = jQuery
import { getSelected } from './helpers/getSelected'

function getSelectedUsers() {
    return getSelected('.js-users-table', 'selected-users')
}

$('.js-block-users').submit(function(e) {
    e.preventDefault()

    const selected = getSelectedUsers()

    $('.js-block-users').find('input[name^="users"]').detach()

    selected.forEach((id, index) => {
        $('.js-block-users').append(`<input type="hidden" name="users[${index}]" value="${id}">`)
    })

    $('.js-block-users').get(0).submit()
})

$('.js-unblock-users').submit(function(e) {
    e.preventDefault()

    const selected = getSelectedUsers()

    $('.js-unblock-users').find('input[name^="users"]').detach()

    selected.forEach((id, index) => {
        $('.js-unblock-users').append(`<input type="hidden" name="users[${index}]" value="${id}">`)
    })

    $('.js-unblock-users').get(0).submit()
})

$('.js-delete-users').submit(function(e) {
    e.preventDefault()

    const selected = getSelectedUsers()

    $('.js-delete-users').find('input[name^="users"]').detach()

    selected.forEach((id, index) => {
        $('.js-delete-users').append(`<input type="hidden" name="users[${index}]" value="${id}">`)
    })

    $('.js-delete-users').get(0).submit()
})
